import React from 'react';
import { useSelector } from 'react-redux';
import { LomavisDemographicsSectionForPlatform1 } from '@/lomavisSharedUi/templates/sections/analytics/lomavisDemographicsSectionForPlatform1';
import { extractDemographicsData } from '../../../redux/slices/analytics/demographics';
import { INSTAGRAM } from '../../../config/constants';
import { useTranslate } from '@tolgee/react';
import { LomavisDataProcessingPlaceholder } from '@/lomavisSharedUi/atoms/placeholders/LomavisDataProcessingPlaceholder';

const InstagramDemographicsTab: React.FC = () => {
  const { t } = useTranslate();
  const { data: demographicsData, isLoading } = useSelector(
    (state: any) => state.demographics
  );

  return (
    <div className="border-1 border-gray-200 p-4 rounded-lg h-100 w-100">
      {Object.keys(demographicsData).length > 0 && (
        <LomavisDemographicsSectionForPlatform1
          title={'allAnalytics.demographics.title'}
          platform={INSTAGRAM}
          {...(extractDemographicsData(demographicsData, INSTAGRAM, t) as any)}
        />
      )}
      {!isLoading && Object.keys(demographicsData).length === 0 && (
        <LomavisDataProcessingPlaceholder />
      )}
    </div>
  );
};

export default InstagramDemographicsTab;
